<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-align-right`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0391 1.16992C14.4974 1.16995 14.8691 1.54162 14.8691 2V14C14.8691 14.4584 14.4974 14.83 14.0391 14.8301C13.5807 14.8301 13.209 14.4584 13.209 14V2C13.209 1.5416 13.5807 1.16992 14.0391 1.16992ZM11.3193 12.8301H5.61816C5.15992 12.8299 4.78809 12.4583 4.78809 12C4.78809 11.5417 5.15992 11.1701 5.61816 11.1699H11.3193V12.8301ZM11.3193 7.16992V8.83008H1.16504C0.706755 8.82995 0.334961 8.45831 0.334961 8C0.334961 7.54169 0.706755 7.17005 1.16504 7.16992H11.3193ZM11.3193 4.83008H3.70996C3.25158 4.83007 2.87988 4.45839 2.87988 4C2.87988 3.54161 3.25158 3.16993 3.70996 3.16992H11.3193V4.83008Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAlignRight',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
